import draxLogo from "public/images/logo.svg";
import { AccessItem, FrameConsumer, DropdownItem, AccountItem } from "@weezevent/nacre";
import { MenuProvider, MenuButton } from "nacre/menu";
import React from "react";
import PropTypes from "prop-types";
import { useTranslation} from "react-i18next";
import { organizations } from "api/state";
import { useAuth } from 'react-oidc-context';

const TICKET_PREFIX = `${window.weezConfig.front.weezeventAdminUrl}/ticket`;

function Viewport({
	children,
}) {
	const {t} = useTranslation();

	const organization = organizations.useCurrent();
	const auth = useAuth();
	const profile = auth.user.profile;

	const name = profile.name || `${profile.data?.firstname || '' } ${profile.data?.name || ''}`;
	const email = profile.email || profile.data?.email || '';

	const manageAccount = () => {
		// It works with keycloak, but it's not standard
		window.location = `${auth.settings.authority}/account`;
	};

	return <div className="wz-height-medium" >
		<MenuProvider>
			<div className="wz-topmenu" >
				<MenuButton />
				<div className="wz-universe" >
					<div className="wz-logo" style={ {
						backgroundImage: `url(${ draxLogo })`,
					} } />
				</div>
				<FrameConsumer.Module>
					<FrameConsumer.Module.Apps>
						<DropdownItem.Title title={ t(["top-bar.switch-to", "Switch to"]) } />
						<FrameConsumer.Module.Apps.Ticket
							key="weezticket"
							as="a"
							href={ organization ? `${TICKET_PREFIX}/O${organization.getWeezID()}` : TICKET_PREFIX }
							label={ t(["top-bar.apps.weezticket", "Ticketing & Registration"]) }
							target="_blank"
						/>
						{
							organization && <AccessItem
								as="a"
								href={ `${window.weezConfig.front.weezeventAdminUrl}/access/O${organization?.getWeezID()}/home` }
								label={ t(["top-bar.apps.weezaccess", "Access Control"]) }
								target="_blank"
							/>
						}
					</FrameConsumer.Module.Apps>
					{ organization &&
						<FrameConsumer.Module.Account
							content={ name }
							items={
								<AccountItem
									mail={ email }
									primary={ {
										onClick: manageAccount,
										label: t(["account.title", "My Account"])
									} }
									secondary={ {
										onClick: () => {
											auth.removeUser();
											auth.logoutRedirect({
												post_logout_redirect_url:  `${window.location.origin}/target/`,
											});
										},
										label: t(["account.logout", "Log out"])
									} }
									subtitle={ t(["account.subtitle", "My profile"]) }
									title={ name }
								/>
							}
						/>
					}
				</FrameConsumer.Module>
			</div>

			<div className="wz-container">
				{ children }
			</div>
		</MenuProvider>
	</div>;
}

Viewport.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Viewport;
